import { useEffect, useState } from 'react';
import api from '../api';

export default function PlanExpiredPopup() {
  const [show, setShow] = useState(false);
  const [username, setUsername] = useState('');

  const check = async () => {
    try {
      const { data } = await api.get('user/profile/');
      const resumenOnly = !!data?.resumen_only;
      const state = String(data?.plan_state || 'unknown');
      const mustShow = resumenOnly || state === 'expired';
      setShow(mustShow);
      setUsername(data?.username || '');
    } catch {
      // si no hay sesión o falla, no mostramos
      setShow(false);
    }
  };

  useEffect(() => {
    check();
    const onRef = () => check();
    try { window.addEventListener('auth:token_refreshed', onRef); } catch {}
    const id = setInterval(check, 30000);
    return () => { try { window.removeEventListener('auth:token_refreshed', onRef); } catch {}; clearInterval(id); };
  }, []);

  if (!show) return null;

  return (
    <div style={{ position:'fixed', zIndex: 9999, inset: 0, display:'flex', alignItems:'flex-end', pointerEvents:'none' }}>
      <div style={{ width:'100%', pointerEvents:'auto' }}>
        <div style={{
          margin:'0 auto 12px', maxWidth: 960, background:'#0f172a', color:'#e2e8f0', padding:'14px 16px',
          border:'1px solid #1f2937', borderRadius:12, boxShadow:'0 10px 30px rgba(0,0,0,0.35)'
        }}>
          <div style={{ display:'flex', gap:12, alignItems:'center', flexWrap:'wrap', justifyContent:'space-between' }}>
            <div style={{ fontSize:14, lineHeight:1.4 }}>
              <div style={{ fontWeight:700, marginBottom:4 }}>🚫⏳ Tu período de prueba ha terminado</div>
              <div>
                Obtén acceso ilimitado por solo <b>$30/mes</b>. <span role="img" aria-label="fire">🔥</span>
                <br />
                <b>¡ACEPTA ESTA OFERTA!</b> (10% de descuento) si actualizas dentro de las próximas <b>48 h</b>.
              </div>
            </div>
            <a href="/renovacion" style={{
              background: 'linear-gradient(90deg, #06b6d4, #2563eb)', color:'#fff', textDecoration:'none',
              padding:'10px 14px', borderRadius:10, fontWeight:700, whiteSpace:'nowrap'
            }}>
              Ir a Renovación ➜
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
